import type { IIssueInProgressDailyTrendRow, IWipTrendPoint } from '@skystone/shared';

// ---------------------------------------------------------------------------
// PRODOPSAI-418 — IWipTrendPoint → IIssueInProgressDailyTrendRow adapter
//
// The canonical `portfolioApi.getWipTrend(...)` returns
// `{ date, issueType, teamId, teamName, count }` per (snapshot_date,
// issue_type, team_id). The legacy `issueInProgressDailyApi.getTrend(...)`
// returned `{ snapshotDate, issueType, teamName, distinctCount }` per the
// same partition. Field names differ, semantics are identical.
//
// The trend consumers (WipTrendCard, WipSummaryCard) plus
// their helpers (`bucketDailyWipToWeekly`, `wipWeeklyAverage`,
// `monthlyAverageByType`) were already
// correct against the legacy shape. Adapting at the call site keeps that
// helper code unchanged — important to preserve the existing aggregation
// snapshot tests and the "zero visible UI delta" acceptance criterion.
// ---------------------------------------------------------------------------

/**
 * Map the canonical `IWipTrendPoint[]` shape onto the legacy
 * `IIssueInProgressDailyTrendRow[]` shape consumed by the existing
 * bucketing/aggregation helpers. Pure projection — no filtering, no
 * regrouping. `teamId` is dropped because the legacy shape keyed only on
 * `teamName`; the consumers that filter by team scope already use
 * `teamName` (matches `IIssueCurrent.teamName` for unified options).
 */
export function adaptWipTrendPointsToLegacyRows(
  points: IWipTrendPoint[],
): IIssueInProgressDailyTrendRow[] {
  return points.map((p) => ({
    snapshotDate: p.date,
    issueType: p.issueType,
    teamName: p.teamName,
    distinctCount: p.count,
  }));
}
